<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="main">
      <navMenu :active="active"></navMenu>
      <div class="content" v-loading.fullscreen.lock="loading">
        <div class="content-top">
          <div class="go-back" @click="goBack">返回</div>
          <el-button @click="addProduct" :disabled="btnDisabled"
            >保存</el-button
          >
        </div>
        <!-- 表单信息 -->
        <div class="productContent">
          <div class="main-title">
            {{ forms.id ? "编辑产品" : "添加产品" }}
          </div>
          <div class="title">基本信息</div>
          <div class="product-item">
            <span class="product-title">所属公司：{{ forms.companyName }}</span>
          </div>
          <div class="product-item">
            <div class="product-left">
              <span class="colorRed">*</span>产品名称：
            </div>
            <div class="product-right">
              <el-input
                v-model="forms.goodsName"
                placeholder="请输入产品名称"
              ></el-input>
            </div>
          </div>
          <div class="product-item">
            <div class="product-left">
              <span class="colorRed">*</span>产品大类：
            </div>
            <div class="product-right">
              <el-select
                v-model="forms.category"
                placeholder="请选择"
                @change="getCategory($event)"
              >
                <el-option
                  v-for="item in productCategories"
                  :key="item.id"
                  :label="item.val"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="product-item">
            <div class="product-left">
              <span class="colorRed">*</span>产品类别一级：
            </div>
            <div class="product-right">
              <el-select
                v-model="forms.productClass1"
                placeholder="请选择"
                @change="productClass1Change"
              >
                <el-option
                  v-for="item in productategory"
                  :key="item.id"
                  :label="item.val"
                  :value="item.id"
                >
                </el-option>
              </el-select>
              <!-- 如果是营养保健品下产品类别一级选的其他显示 -->
              <div v-if="forms.productClass1 == '其他'" class="others">
                <el-input
                  v-model="productClass1ValCustom"
                  placeholder="请输入产品类别一级内容"
                ></el-input>
              </div>
            </div>
          </div>

          <div class="product-item" v-if="forms.productClass1 != '其他'">
            <div class="product-left">
              <span class="colorRed">*</span>产品类别二级：
            </div>
            <div class="product-right">
              <el-select v-model="forms.productClass2" placeholder="请选择">
                <el-option
                  v-for="item in productategory2"
                  :key="item.id"
                  :label="item.val"
                  :value="item.val"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <!-- 产品特点PC药品 -->
          <!-- 24.9.12 最多三项改成五项 dxm -->
          <div class="product-item" v-if="!shownutrition">
            <div class="product-left">产品特点（最多选五项）：</div>
            <div class="product-right">
              <el-checkbox-group v-model="features" @change="getfeatures">
                <el-checkbox
                  v-for="item in productFeature"
                  :id="item.val"
                  :value="item.val"
                  :key="item.id"
                  :label="item.val"
                  >{{ item.val }}</el-checkbox
                >
              </el-checkbox-group>
              <div v-if="showfeaturesValCustom" class="others">
                <el-input
                  v-model="featuresValCustom"
                  placeholder="请输入自定义产品特点"
                ></el-input>
              </div>
            </div>
          </div>
          <!-- 产品特点营养保健品 -->
          <div class="product-item" v-if="shownutrition">
            <div class="product-left">产品特点（最多选五项）：</div>
            <div class="product-right">
              <el-checkbox-group v-model="features" @change="getfeatures">
                <el-checkbox
                  v-for="item in productnutrition"
                  :id="item.val"
                  :value="item.val"
                  :key="item.id"
                  :label="item.val"
                  >{{ item.val }}</el-checkbox
                >
              </el-checkbox-group>
            </div>
          </div>
          <!-- 24.9.12 产品特点选择集采产品 dxm -->
          <div class="product-item" v-if="isCpurchasing">
            <div class="product-left">
              <span class="colorRed">*</span>集采中标情况：
            </div>
            <div class="product-right">
              <el-radio-group v-model="forms.c_purchasing_bid">
                <el-radio
                  v-for="item in cpurchasingOptions"
                  :key="item.key"
                  :label="item.key"
                  >{{ item.value }}</el-radio
                >
              </el-radio-group>
            </div>
          </div>
          <!-- 24.9.12 产品特点选择国谈产品 dxm -->
          <div class="product-item" v-if="isGpurchasing">
            <div class="product-left">
              <span class="colorRed">*</span>国谈中标情况：
            </div>
            <div class="product-right">
              <el-radio-group v-model="forms.g_purchasing_bid">
                <el-radio
                  v-for="item in gpurchasingOptions"
                  :key="item.key"
                  :label="item.key"
                  >{{ item.value }}</el-radio
                >
              </el-radio-group>
            </div>
          </div>
          <div class="product-item">
            <div class="product-left">搜索标签：</div>
            <div class="product-right">
              <el-input
                v-model="forms.search_label"
                placeholder="每个搜索标签不能超过4个字，多标签用逗号隔开(便于客户找到您的产品)"
              ></el-input>
              <div style="padding-top: 10px; font-size: 12px">
                每个搜索标签不能超过4个字，多标签用逗号隔开(便于客户找到您的产品)
              </div>
            </div>
          </div>
          <div class="product-item" v-show="showlist_year">
            <div class="product-left">
              <span class="colorRed">*</span>上市年份：
            </div>
            <div class="product-right">
              <el-date-picker
                v-model="forms.list_year"
                type="year"
                format="yyyy"
                placeholder="输入上市年份"
                @on-change="getListy"
              >
              </el-date-picker>
            </div>
          </div>
          <div class="product-item" v-show="showlist_year">
            <div class="product-left">
              <span class="colorRed">*</span>上传新药证书：
            </div>
            <div class="product-right">
              <div class="image" v-if="forms.certificate">
                <el-image :src="$imgOssUrl + forms.certificate"></el-image>
                <div class="upload-span">
                  <span
                    class="upload-icon"
                    @click.stop="
                      handlePictureCardPreview($imgOssUrl + forms.certificate)
                    "
                    ><i class="el-icon-zoom-in"></i
                  ></span>
                  <span
                    class="upload-icon"
                    @click.stop="handleCertificateRemove()"
                    style="margin-left: 20px"
                    ><i class="el-icon-delete"></i
                  ></span>
                </div>
              </div>
              <div v-if="!forms.certificate">
                <el-upload
                  :action="$Url"
                  list-type="picture-card"
                  :headers="headers"
                  :multiple="false"
                  :before-upload="beforeUpload"
                  :on-progress="handleProgressCertificate"
                  :on-success="handleCertificateSuccess"
                  :on-error="handleCertificateError"
                  :show-file-list="false"
                >
                  <i
                    class="el-icon-plus"
                    v-if="!progressCertificateVisible"
                  ></i>
                  <div
                    v-if="progressCertificateVisible"
                    style="padding-top: 30px"
                  >
                    <el-progress
                      :percentage="progressCertificatePercent"
                      type="circle"
                      :width="80"
                    ></el-progress>
                  </div>
                </el-upload>
              </div>
            </div>
          </div>
          <div class="product-item">
            <div class="product-left">
              <span class="colorRed">*</span>产品图片：
            </div>
            <div class="product-right" style="display: block">
              <div style="display: flex; flex-wrap: wrap">
                <div class="image-wrap" v-if="forms.imgs">
                  <div
                    class="image"
                    v-for="(item, index) in forms.imgs"
                    :key="item.url"
                  >
                    <el-image
                      v-if="item.includes('https://oss.larspring.com')"
                      :src="item"
                    ></el-image>
                    <el-image
                      v-else-if="item.includes('/var/')"
                      :src="$imgOssUrl + item.substring(1)"
                    ></el-image>
                    <el-image v-else :src="$imgOssUrl + item"></el-image>
                    <div class="upload-span">
                      <span
                        v-if="item.includes('https://oss.larspring.com')"
                        class="upload-icon"
                        @click.stop="handlePictureCardPreview(item)"
                        ><i class="el-icon-zoom-in"></i
                      ></span>
                      <span
                        class="upload-icon"
                        v-else-if="item.includes('/var/')"
                        @click.stop="
                          handlePictureCardPreview(
                            $imgOssUrl + item.substring(1)
                          )
                        "
                        ><i class="el-icon-zoom-in"></i
                      ></span>
                      <span
                        class="upload-icon"
                        v-else
                        @click.stop="
                          handlePictureCardPreview($imgOssUrl + item)
                        "
                        ><i class="el-icon-zoom-in"></i
                      ></span>
                      <span
                        class="upload-icon"
                        @click.stop="handleImgRemove(index)"
                        style="margin-left: 20px"
                        ><i class="el-icon-delete"></i
                      ></span>
                    </div>
                  </div>
                </div>
                <div v-if="forms.imgs.length < 5">
                  <el-upload
                    :action="$Url"
                    list-type="picture-card"
                    :headers="headers"
                    :multiple="false"
                    :before-upload="beforeUpload"
                    :on-progress="handleProgressImgs"
                    :on-success="handleImgsSuccess"
                    :on-error="handleImgsError"
                    :show-file-list="false"
                  >
                    <i class="el-icon-plus" v-if="!progressImgsVisible"></i>
                    <div v-if="progressImgsVisible" style="padding-top: 30px">
                      <el-progress
                        :percentage="progressImgsPercent"
                        type="circle"
                        :width="80"
                      ></el-progress>
                    </div>
                  </el-upload>
                </div>
              </div>
              <p class="colorf90 margint10px">
                附件仅限JPG、JPEG、PNG格式，大小不超过2M，分辨率不小于300dpi最多可上传5个文件
              </p>
              <p class="colorf90 margint10px">仅限上传产品外观图片</p>
            </div>
          </div>
          <div class="product-item">
            <div class="product-left">商品名/商标：</div>
            <div class="product-right">
              <el-input
                v-model="forms.trademark"
                placeholder="请输入商品名/商标"
              ></el-input>
            </div>
          </div>
          <!-- PC药品相关筛选项 -->
          <div v-if="shownutritions">
            <div class="product-item" v-show="showotc && categoryId == 1">
              <div class="product-left">
                <span class="colorRed">*</span>OTC/处方药：
              </div>
              <div class="product-right">
                <el-select v-model="forms.is_otc" placeholder="请选择">
                  <el-option
                    v-for="item in OTCRxDrug"
                    :key="item.id"
                    :label="item.val"
                    :value="item.val"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="product-item" v-if="forms.productClass1 == '化学药'">
              <div class="product-left">
                <span class="colorRed">*</span>是否通过一致性评价：
              </div>
              <div class="product-right">
                <el-radio-group v-model="forms.is_uniformity">
                  <el-radio
                    v-for="item in is_uniformity"
                    :key="item.id"
                    :label="item.id"
                    >{{ item.val }}</el-radio
                  >
                </el-radio-group>
              </div>
            </div>
            <div class="product-item" v-if="categoryId == 1">
              <div class="product-left">
                <span class="colorRed">*</span>是否带量采购品种：
              </div>
              <div class="product-right">
                <el-radio-group v-model="forms.is_amount">
                  <el-radio
                    v-for="item in is_amount"
                    :key="item.id"
                    :label="item.id"
                    >{{ item.val }}</el-radio
                  >
                </el-radio-group>
              </div>
            </div>
            <!-- 24.9.12 是否中标改成是否中标/挂网 dxm -->
            <div class="product-item">
              <div class="product-left">
                <span
                  class="colorRed"
                  v-if="
                    forms.category == '药品' || forms.category == '医疗器械'
                  "
                  >*</span
                >是否中标/挂网：
              </div>
              <div class="product-right">
                <el-radio-group v-model="forms.is_bid">
                  <el-radio
                    v-for="item in outbids"
                    :key="item.id"
                    :label="item.id"
                    >{{ item.val }}</el-radio
                  >
                </el-radio-group>
              </div>
            </div>
            <!-- 24.9.12 中标区域改成中标/挂网区域 dxm -->
            <div class="product-item" v-if="forms.is_bid == '1'">
              <div class="product-left">
                <span
                  class="colorRed"
                  v-if="
                    forms.category == '药品' || forms.category == '医疗器械'
                  "
                  >*</span
                >中标/挂网区域：
              </div>
              <div class="product-right">
                <el-checkbox-group v-model="bid_area">
                  <el-checkbox
                    v-for="item in winningArea"
                    :id="item.val"
                    :value="item.val"
                    :key="item.id"
                    :label="item.val"
                    >{{ item.val }}</el-checkbox
                  >
                </el-checkbox-group>
              </div>
            </div>
            <!-- 24.9.12  增加关联题，选择中标/挂网区域任意选项后，弹出填空题，最低挂网价格及省份，设置为必填 dxm-->
            <div class="product-item" v-if="bid_area.length > 0">
              <div class="product-left">
                <span class="colorRed">*</span>最低挂网价格及省份：
              </div>
              <div class="product-right">
                <el-input
                  v-model="forms.prices_provincial_min"
                  placeholder="最低挂网价格及省份"
                ></el-input>
              </div>
            </div>
            <div class="product-item" v-show="cid == 6">
              <div class="product-left">是否民族药：</div>
              <div class="product-right">
                <el-radio-group v-model="forms.is_ethnic">
                  <el-radio
                    v-for="item in ethnodrug"
                    :key="item.id"
                    :label="item.id"
                    >{{ item.val }}</el-radio
                  >
                </el-radio-group>
              </div>
            </div>
            <div
              class="product-item"
              v-show="forms.is_ethnic == '1' && cid == 6"
            >
              <div class="product-left">民族药：</div>
              <div class="product-right">
                <el-select v-model="forms.ethnic" placeholder="请选择">
                  <el-option
                    v-for="item in ethnodrugs"
                    :key="item.id"
                    :label="item.val"
                    :value="item.val"
                  >
                  </el-option>
                </el-select>
                <div class="others" v-show="showethnodrugValCustom">
                  <el-input
                    v-model="ethnodrugValCustom"
                    placeholder="请输入民族药"
                  ></el-input>
                </div>
              </div>
            </div>
            <div class="product-item">
              <div class="product-left" v-show="categoryId != 4">
                <span class="colorRed">*</span>是否临床：
              </div>
              <div class="product-right" v-show="categoryId != 4">
                <el-radio-group v-model="forms.is_clinical">
                  <el-radio
                    v-for="item in Isclinic"
                    :key="item.id"
                    :label="item.id"
                    >{{ item.val }}</el-radio
                  >
                </el-radio-group>
              </div>
            </div>
            <div
              class="product-item"
              v-if="forms.is_clinical == '1' && categoryId != 4"
            >
              <div class="product-left">
                <span class="colorRed">*</span>临床科室（最多三项）：
              </div>
              <div class="product-right">
                <el-checkbox-group v-model="clinical" @change="getclinical">
                  <el-checkbox
                    v-for="item in clinic"
                    :id="item.val"
                    :value="item.val"
                    :key="item.id"
                    :label="item.val"
                    >{{ item.val }}</el-checkbox
                  >
                </el-checkbox-group>
                <div class="others" v-show="showeclinicalValCustom">
                  <el-input
                    v-model="clinicalValCustom"
                    placeholder="请输入临床科室"
                  ></el-input>
                </div>
              </div>
            </div>

            <div class="product-item">
              <div class="product-left">
                <span class="colorRed" v-if="forms.category != '技术与服务'"
                  >*</span
                >产品渠道：
              </div>
              <div class="product-right">
                <el-input
                  style="width: 70%"
                  class="channels-input"
                  v-model="allproducChannel"
                  placeholder="请点击右侧按钮进行选择"
                ></el-input>
                <div class="channels" @click="getChannel">请选择产品渠道</div>
                <div class="others" v-if="showProductChannelsValcustom">
                  <el-input
                    v-model="ProductChannelsValcustom"
                    placeholder="请填写其他渠道内容"
                    class="channels-input"
                    @change="getProductChannelsValcustom"
                  ></el-input>
                </div>
              </div>
            </div>
          </div>
          <!--24.9.12 产品渠道下方增加单选题：产品院外处方流转情况，只有选药品大类里的化学药、中成药、生物医药才出（必填) dxm -->
          <div
            class="product-item"
            v-if="
              forms.productClass1 == '化学药' ||
              forms.productClass1 == '中成药' ||
              forms.productClass1 == '生物医药'
            "
          >
            <div class="product-left">
              <span class="colorRed">*</span>产品院外处方流转情况：
            </div>
            <div class="product-right">
              <el-radio-group
                v-model="forms.prescription_circulation"
                @input="changePrescriptionCirculation"
              >
                <el-radio
                  v-for="item in prescriptionOptions"
                  :key="item.key"
                  :label="item.key"
                  >{{ item.value }}</el-radio
                >
              </el-radio-group>
            </div>
          </div>
          <!-- 24.9.12 产品院外处方流转情况选了已进行或希望开展的，增加以下问题，四同价格、建议零售价、电商平台是否有货、电商最低价格-->
          <div
            class="product-item"
            v-if="
              forms.prescription_circulation == '已进行' ||
              forms.prescription_circulation == '希望开展'
            "
          >
            <div class="product-left">四同价格：</div>
            <div class="product-right">
              <el-input
                v-model="forms.f_identical_prices"
                placeholder="请填写四同价格"
              ></el-input>
            </div>
          </div>
          <div
            class="product-item"
            v-if="
              forms.prescription_circulation == '已进行' ||
              forms.prescription_circulation == '希望开展'
            "
          >
            <div class="product-left">
              <span class="colorRed">*</span>建议零售价：
            </div>
            <div class="product-right">
              <el-input
                v-model="forms.msrp"
                placeholder="请填写建议零售价"
              ></el-input>
            </div>
          </div>
          <div
            class="product-item"
            v-if="
              forms.prescription_circulation == '已进行' ||
              forms.prescription_circulation == '希望开展'
            "
          >
            <div class="product-left">
              <span class="colorRed">*</span>电商平台是否有货：
            </div>
            <div class="product-right">
              <el-radio-group v-model="forms.online_available">
                <el-radio
                  v-for="item in onlineAvailableOptions"
                  :key="item.key"
                  :label="item.key"
                  >{{ item.value }}</el-radio
                >
              </el-radio-group>
            </div>
          </div>
          <div
            class="product-item"
            v-if="
              forms.prescription_circulation == '已进行' ||
              forms.prescription_circulation == '希望开展'
            "
          >
            <div class="product-left">电商最低价格：</div>
            <div class="product-right">
              <el-input
                v-model="forms.online_price_min"
                placeholder="请填写电商最低价格"
              ></el-input>
            </div>
          </div>
          <div class="product-item">
            <div class="product-left">
              <span class="colorRed" v-if="forms.category != '技术与服务'"
                >*</span
              >产品资质：
            </div>
            <div class="product-right">
              <el-select
                v-model="qualificationVal"
                placeholder="请选择"
                @change="getQualificationVal($event)"
              >
                <el-option
                  v-for="item in ProductQualification"
                  :key="item.id"
                  :label="item.val"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="product-item" v-if="qualificationNone">
            <div class="product-left">
              <span class="colorRed" v-if="forms.category != '技术与服务'"
                >*</span
              >产品资质号：
            </div>
            <div class="product-right">
              <el-input
                v-model="qualification_no"
                placeholder="请输入产品资质号(不需要再重复输入所选的选项)"
              ></el-input>
            </div>
          </div>
          <div
            class="product-item"
            v-if="qualificationVal != '无特殊资质' && qualificationVal != '无'"
          >
            <div class="product-left">
              <span class="colorRed" v-if="forms.category != '技术与服务'"
                >*</span
              >上传资质文件：
            </div>
            <div class="product-right">
              <div>
                <div class="image" v-if="forms.qualification_file">
                  <el-image
                    v-if="
                      forms.qualification_file.includes(
                        'https://oss.indata3.com'
                      )
                    "
                    :src="forms.qualification_file"
                  ></el-image>
                  <el-image
                    v-else
                    :src="$imgOssUrl + forms.qualification_file"
                  ></el-image>
                  <div class="upload-span">
                    <span
                      class="upload-icon"
                      @click.stop="
                        handlePictureCardPreview(
                          forms.qualification_file.includes(
                            'https://oss.indata3.com'
                          )
                            ? forms.qualification_file
                            : $imgOssUrl + forms.qualification_file
                        )
                      "
                      ><i class="el-icon-zoom-in"></i
                    ></span>
                    <span
                      class="upload-icon"
                      @click.stop="handleQfRemove()"
                      style="margin-left: 20px"
                      ><i class="el-icon-delete"></i
                    ></span>
                  </div>
                </div>
                <div v-if="!forms.qualification_file">
                  <el-upload
                    :action="$Url"
                    list-type="picture-card"
                    :headers="headers"
                    :multiple="false"
                    :before-upload="beforeUpload"
                    :on-progress="handleProgressQf"
                    :on-success="handleQfSuccess"
                    :on-error="handleQfError"
                    :show-file-list="false"
                  >
                    <i class="el-icon-plus" v-if="!progressQfVisible"></i>
                    <div v-if="progressQfVisible" style="padding-top: 30px">
                      <el-progress
                        :percentage="progressQfPercent"
                        type="circle"
                        :width="80"
                      ></el-progress>
                    </div>
                  </el-upload>
                </div>
              </div>
            </div>
          </div>
          <div
            class="product-item"
            v-show="
              qualificationNone &&
              forms.category != '营养保健' &&
              forms.category != '原料/包材/设备'
            "
          >
            <div class="product-left">
              <span class="colorRed" v-if="forms.category != '技术与服务'"
                >*</span
              >获批时间：
            </div>
            <div class="product-right">
              <el-date-picker
                v-model="forms.approval_time"
                type="date"
                format="yyyy-MM-dd"
                placeholder="输入获批时间"
                @on-change="geApproval"
                :picker-options="pickerOption"
              >
              </el-date-picker>
            </div>
          </div>
          <div class="product-item" v-if="!shownutritions">
            <div class="product-left">
              <span class="colorRed">*</span>是否进口：
            </div>
            <div class="product-right">
              <div>
                <el-radio-group v-model="forms.is_import">
                  <el-radio
                    v-for="item in entrance"
                    :key="item.id"
                    :label="item.id"
                    >{{ item.val }}</el-radio
                  >
                </el-radio-group>
              </div>
            </div>
          </div>
          <div class="product-item" v-if="!shownutritions">
            <div class="product-left">
              <span class="colorRed">*</span>销售渠道（最多三项）：
            </div>
            <div class="product-right">
              <div>
                <el-checkbox-group
                  v-model="distributionChannelVal1"
                  @change="getdistribution"
                >
                  <el-checkbox
                    v-show="showdistributionChannel1"
                    v-for="item in distributionChannel1"
                    :id="item.val"
                    :value="item.val"
                    :key="item.id"
                    :label="item.val"
                    >{{ item.val }}</el-checkbox
                  >
                  <el-checkbox
                    v-show="showdistributionChannel2"
                    v-for="item in distributionChannel2"
                    :id="item.val"
                    :value="item.val"
                    :key="item.id"
                    :label="item.val"
                    >{{ item.val }}</el-checkbox
                  >
                  <el-checkbox
                    v-if="forms.is_import !== ''"
                    id="其他"
                    label="其他"
                    >其他</el-checkbox
                  >
                </el-checkbox-group>
                <div v-if="showdistributionChannelVal1">
                  <el-input
                    v-model="distributionChannelVal1Custom"
                    placeholder="请输入销售渠道内容"
                  ></el-input>
                </div>
              </div>
            </div>
          </div>
          <div class="product-item">
            <div class="product-left">
              <span class="colorRed" v-if="forms.category != '技术与服务'"
                >*</span
              >生产厂家：
            </div>
            <div class="product-right">
              <el-input
                v-model="forms.producer"
                placeholder="请输入生产厂家"
              ></el-input>
            </div>
          </div>

          <div class="product-item">
            <div class="product-left">
              <span class="colorRed" v-if="forms.category != '技术与服务'"
                >*</span
              >产品规格：
            </div>
            <div class="product-right">
              <el-input
                v-model="forms.specifications"
                placeholder="请输入产品规格"
              ></el-input>
            </div>
          </div>
          <div class="product-item" v-if="shownutritions && categoryId == 1">
            <div class="product-left">
              <span class="colorRed">*</span>产品剂型：
            </div>
            <div class="product-right">
              <el-select
                v-model="forms.reagent_type"
                placeholder="请选择产品剂型"
              >
                <el-option
                  v-for="item in ProductFormulations"
                  :key="item.val"
                  :label="item.val"
                  :value="item.val"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="product-item">
            <div class="product-left">
              <span class="colorRed">*</span>招商区域：
            </div>
            <div class="product-right">
              <el-checkbox-group v-model="investment_area" @change="getarea">
                <el-checkbox
                  v-for="item in investmentArea"
                  :id="item.val"
                  :value="item.val"
                  :key="item.id"
                  :label="item.val"
                  >{{ item.val }}</el-checkbox
                >
              </el-checkbox-group>
            </div>
          </div>
          <div class="product-item" v-if="shownutritions && categoryId == 1">
            <div class="product-left">
              <span class="colorRed">*</span>功能主治/适应症：
            </div>
            <div class="product-right">
              <el-input
                type="textarea"
                :maxlength="1000"
                show-word-limit
                :rows="5"
                resize="none"
                v-model="forms.indications"
                placeholder="填写内容请与产品说明书一致，否则法律风险自担"
              ></el-input>
            </div>
          </div>
          <!-- 24.9.12 选药品大类的，在功能主治/适应症下面加一个用法用量的填空题 dxm -->
          <div v-if="forms.category == '药品'" class="product-item">
            <div class="product-left">
              <span class="colorRed">*</span>用法用量：
            </div>
            <div class="product-right">
              <el-input
                type="textarea"
                :maxlength="500"
                show-word-limit
                :rows="5"
                resize="none"
                v-model="forms.dosage"
                placeholder="请输入"
              ></el-input>
            </div>
          </div>
          <div class="product-item" v-if="categoryId > 1">
            <div class="product-left">
              <span class="colorRed">*</span>产品介绍：
            </div>
            <div class="product-right">
              <el-input
                type="textarea"
                :maxlength="1000"
                show-word-limit
                :rows="5"
                resize="none"
                v-model="forms.introduction"
                placeholder="填写内容请与产品说明书一致，否则法律风险自担"
              ></el-input>
            </div>
          </div>
          <div v-if="!shownutritions" class="product-item">
            <div class="product-left">成分：</div>
            <div class="product-right">
              <el-input
                type="textarea"
                :maxlength="500"
                show-word-limit
                :rows="5"
                resize="none"
                v-model="forms.component"
                placeholder="请输入"
              ></el-input>
            </div>
          </div>
          <div v-if="!shownutritions" class="product-item">
            <div class="product-left">用法用量：</div>
            <div class="product-right">
              <el-input
                type="textarea"
                :maxlength="500"
                show-word-limit
                :rows="5"
                resize="none"
                v-model="forms.dosage"
                placeholder="请输入"
              ></el-input>
            </div>
          </div>
          <!-- 24.9.12 增加产品优势 dxm -->
          <div class="product-item">
            <div class="product-left">
              <span class="colorRed">*</span>产品优势：
            </div>
            <div class="product-right">
              <el-input
                type="textarea"
                :maxlength="100"
                show-word-limit
                :rows="5"
                resize="none"
                v-model="forms.advantages"
                placeholder="请输入"
              ></el-input>
            </div>
          </div>
          <div class="product-item">
            <div class="product-left">对代理商要求：</div>
            <div class="product-right">
              <el-input
                type="textarea"
                :maxlength="500"
                show-word-limit
                :rows="5"
                resize="none"
                v-model="forms.agent_regulations"
                placeholder="请输入"
              ></el-input>
            </div>
          </div>
          <div class="product-item">
            <div class="product-left"></div>
            <div class="product-right">
              <el-checkbox-group
                class="product-checkbox"
                v-model="agent_regulationsList"
              >
                <el-checkbox label="有长期合作的决心"></el-checkbox>
                <el-checkbox label="真诚守信，有良好的商业信誉"></el-checkbox>
                <el-checkbox
                  label="有较强的市场开发能力和市场运作经验"
                ></el-checkbox>
                <el-checkbox
                  label="有一定的经济实力，有完善成熟的销售网络"
                ></el-checkbox>
                <el-checkbox
                  label="具有较强的责任心和合作理念，将企业和自身作为一个有机整体对待"
                ></el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
          <div class="product-item">
            <div class="product-left">对提供的支持：</div>
            <div class="product-right">
              <el-input
                type="textarea"
                :maxlength="500"
                show-word-limit
                :rows="5"
                resize="none"
                v-model="forms.provide_support"
                placeholder="请输入"
              ></el-input>
            </div>
          </div>
          <div class="product-item">
            <div class="product-left"></div>
            <div class="product-right">
              <el-checkbox-group
                class="product-checkbox"
                v-model="provide_supportList"
              >
                <el-checkbox
                  label="提供合法的经营手续，企业会持续稳定给予代理商做全面服务工作"
                ></el-checkbox>
                <el-checkbox
                  label="广阔的市场操作空间，保证代理商的利润，立足长远发展，互利双赢"
                ></el-checkbox>
                <el-checkbox
                  label="有力的市场保护，确保区域独家代理权，确保运营商的权益"
                ></el-checkbox>
                <el-checkbox
                  label="及时提供货源，确保全国范围内2～10天内到货"
                ></el-checkbox>
                <el-checkbox
                  label="随货带宣传资料，完成任务年终返点"
                ></el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
          <div class="title">联系方式</div>
          <div class="product-list">
            <div class="product-item">
              <div class="product-left">
                <span class="colorRed">*</span>联系人：
              </div>
              <div class="product-right">
                <el-input
                  v-model="forms.contacts"
                  placeholder="请输入"
                ></el-input>
              </div>
            </div>
            <div class="product-item">
              <div class="product-left">
                <span class="colorRed">*</span>手机：
              </div>
              <div class="product-right">
                <el-input
                  style="width: 60%"
                  v-model.number="forms.phone"
                  :maxlength="11"
                  placeholder="请输入"
                ></el-input>
                <el-checkbox
                  v-model="wxPhones"
                  @change="issync_wechat"
                  style="margin-left: 5px; line-height: 40px"
                  >微信同号</el-checkbox
                >
              </div>
            </div>
            <div class="product-item">
              <div class="product-left">微信：</div>
              <div class="product-right">
                <el-input
                  v-model="forms.wechat"
                  placeholder="请输入"
                ></el-input>
              </div>
            </div>
            <div class="product-item">
              <div class="product-left">qq：</div>
              <div class="product-right">
                <el-input v-model="forms.qq" placeholder="请输入"></el-input>
              </div>
            </div>
            <div class="product-item">
              <div class="product-left">电子邮箱：</div>
              <div class="product-right">
                <el-input
                  v-model="forms.email"
                  placeholder="请输入"
                  @blur="testEmail()"
                ></el-input>
              </div>
            </div>
            <div class="product-item">
              <div class="product-left">电话：</div>
              <div class="product-right">
                <el-input
                  v-model="forms.tel"
                  placeholder="请输入"
                  @blur="testTel()"
                ></el-input>
              </div>
            </div>
            <div class="product-item">
              <div class="product-left">传真：</div>
              <div class="product-right">
                <el-input v-model="forms.fax" placeholder="请输入"></el-input>
              </div>
            </div>
            <div class="product-item">
              <div class="product-left">企业网址：</div>
              <div class="product-right">
                <el-input
                  v-model="forms.website"
                  placeholder="请输入"
                  @blur="testWeb()"
                ></el-input>
              </div>
            </div>
            <div class="product-item">
              <div class="product-left">邮政编码：</div>
              <div class="product-right">
                <el-input
                  v-model="forms.postal_code"
                  placeholder="请输入"
                ></el-input>
              </div>
            </div>
            <div class="product-item">
              <div class="product-left">联系地址：</div>
              <div class="product-right">
                <el-input
                  v-model="forms.contact_address"
                  placeholder="请输入"
                ></el-input>
              </div>
            </div>
            <!-- 24.8.28 隐藏上下架 dxm -->
            <!-- <div class="product-item">
              <div class="product-left"></div>
              <div class="product-right">
                <el-radio-group v-model="forms.status">
                  <el-radio
                    v-for="item in shelves"
                    :key="item.id"
                    :label="item.id"
                    >{{ item.val }}</el-radio
                  >
                </el-radio-group>
              </div>
            </div> -->
          </div>
        </div>
        <div id="producrchannelTree" style="display: none"></div>
        <!-- 产品渠道弹框 -->
        <el-dialog
          :visible.sync="dialogTreeVisible"
          title="选择产品渠道"
          width="600px"
          class="tree-body"
        >
          <!-- :check-strictly="checkStrictly" -->
          <el-tree
            :data="ProductChannelsData"
            show-checkbox
            default-expand-all
            node-key="label"
            ref="tree"
            :check-strictly="checkStrictly"
            :default-checked-keys="ProductChannelsCheckedData"
          >
          </el-tree>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogTreeVisible = false">取 消</el-button>
            <el-button type="primary" @click="handleTreeClick">确 定</el-button>
          </span>
        </el-dialog>
        <div class="bus-btn">
          <el-button @click="addProduct" :disabled="btnDisabled"
            >保存</el-button
          >
        </div>
      </div>
      <el-dialog :visible.sync="dialogVisible">
        <img class="dialog-img" :src="dialogImageUrl" alt="" />
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  productTypelist,
  productDetails,
  addproduct,
  editproduct,
  optionData,
  getCheckBox,
} from "@/api/api";
import top from "../components/top.vue"; //头部
import navMenu from "../components/navMenu.vue"; //左侧步骤条

export default {
  components: { top, navMenu },
  name: "createProduct",
  watch: {
    clinical(newValue, oldValue) {
      if (newValue.indexOf("其他") > -1) {
        this.showeclinicalValCustom = true;
      } else {
        this.showeclinicalValCustom = false;
      }
    },
    //产品大类
    "forms.category"() {
      let plen = this.productFeatures.length;
      if (this.categoryId !== 1) {
        //如果不是药品，不要医保甲类医保乙类
        //this.productFeature = this.productFeatures.slice(2, plen);
        if (this.categoryId != 3 && this.categoryId != 4) {
          //如果不是药品，不要医保甲类医保乙类
          this.productFeature = this.productFeatures.slice(2, plen);
        } else {
          //如果不是药品和医疗器械，不要集采产品／国谈产品
          this.productFeature = this.productFeatures.slice(4, plen);
        }
      } else {
        //是药品，显示全部
        this.productFeature = this.productFeatures;
      }
    },
    //代理商要求
    agent_regulationsList(newValue, oldValue) {
      console.log(newValue);
      this.forms.agent_regulations = newValue.join("\n");
    },
    // 提供的支持
    provide_supportList(newValue, oldValue) {
      console.log(newValue);
      this.forms.provide_support = newValue.join("\n");
    },
    //产品资质
    qualificationVal(newValue, oldValue) {
      console.log(newValue, "=<newValuenewValuenewValuenewValue");
      if (newValue == "无特殊资质" || newValue == "无") {
        this.qualificationNone = false;
        this.forms.approval_time = "";
      } else {
        this.qualificationNone = true;
      }
      if (oldValue != "") {
        //修改产品资质

        if (this.id > 0) {
          // 修改产品详情
          //选择产品资质
          this.forms.qualification_file = "";
          this.qualification_no = "";
        } else {
          //     // 新增产品详情
          this.qualification_no = "";
        }
      }
    },
    //产品类别一级
    "forms.productClass1"(newValue, oldValue) {
      //console.log(newValue, "<=========newValue");
      let cid = "";
      this.productategory.forEach((res) => {
        //console.log(res, "=====res");
        if (res.id == newValue || res.val == newValue) {
          this.forms.productClass1 = res.val;
          cid = res.id;
          this.cid = res.id; //当前产品类别一级id
          this.productategory2 = res.items;
          if (cid == 5 || cid == 6) {
            //产品类别一级选中成药或者化学药，显示OTC/处方药
            this.showotc = true;
            if (cid == 5) {
              // cid=5化学药 cid=6中成药
              //如果是除了化学药,一致性评价为空
              this.forms.is_uniformity =
                oldValue == "" ? this.forms.is_uniformity : "";
              this.forms.ethnic = ""; //只有中诚药关联民族药
            }
          } else {
            this.showotc = false;
            this.forms.is_otc = ""; //如果产品类别一级选其他选项，OTC/处方药为空
            this.forms.ethnic = ""; //只有中诚药关联民族药
          }
          // return res.items
        }
      });
      //营养保健品
      if (
        this.forms.category == "营养保健" ||
        this.forms.category == "原料/包材/设备"
      ) {
        //选的保健食品（蓝帽子）、营养补充剂、特殊医学用途配方食品，填写产品资质相关
        if (cid == 315 || cid == 343 || cid == 357) {
          this.ProductQualification = this.ProductQualificationNutrition;
        } else {
          //否则出现其他产品资质
          this.ProductQualification = this.ProductQualificationNutritionCustom;
        }
      } else {
        //PC药品
        this.ProductQualification = this.ProductQualificationDrug;
      }
      if (newValue == "其他") {
        //产品类别一级选其他
        this.ProductQualification = this.ProductQualificationNutritionCustom;
      }
    },
    // 产品渠道
    allproducChannel(newValue, oldValue) {
      console.log(newValue, "-===newValue其他");
      if (newValue.indexOf("其他") > -1) {
        //如果渠道选其他，输入框显示
        this.showProductChannelsValcustom = true;
      } else {
        this.showProductChannelsValcustom = false;
        this.ProductChannelsValcustom = "";
      }
    },
    //产品渠道其他
    // ProductChannelsValcustom(newValue, oldValue) {
    //   if (newValue != "") {
    //     this.forms.product_channel_class1 +=
    //       this.ProductChannelsValcustom + ",";
    //   }
    // },
    // 产品特点
    features(newValue, oldValue) {
      this.features.map((item, index) => {
        if (item == "") {
          this.features.splice(index, 1);
        }
      });
      //console.log(this.features);
      // 24.9.12 最多三项改成五项 dxm
      if (this.features.length > 5) {
        alert("只能选五项");
        this.features = this.features.slice(0, 5);
      }
      if (newValue.indexOf("自定义") > -1) {
        this.showfeaturesValCustom = true;
      } else {
        this.showfeaturesValCustom = false;
        this.featuresValCustom = "";
      }
      if (newValue.indexOf("新药") > -1) {
        this.showlist_year = true;
      } else {
        this.showlist_year = false;
      }
    },
    // 民族药选其他
    "forms.ethnic"(newValue, oldValue) {
      console.log(newValue);
      if (newValue == "其他") {
        this.showethnodrugValCustom = true;
      } else {
        this.showethnodrugValCustom = false;
        this.forms.ethnic = newValue;
      }
    },
    categoryId(newValue, oldValue) {
      if (oldValue != "") {
        this.features = [];
        if (newValue == "313" || newValue == "314") {
          //产品特点营养保健品显示,并且产品一级可以选其他手动填写
          this.shownutrition = true;
          this.shownutritions = false;
          this.allproducChannel = "";
          if (newValue == 314) {
            //大类是原材，一级二级也要是原材
            let arr = [];
            this.productcategorynutrition.map((item) => {
              if (item.id == 367) {
                arr.push(item);
              }
            }); //367 产品类别一级 原材的id367
            console.log(arr);
            this.productategory = arr;
          } else {
            this.productategory = this.productcategorynutrition; //保健品类别=》产品类别一级
            let len = this.productcategorynutrition.length;
            let cust = { id: "custom", val: "其他" };
            console.log(this.productategory[len - 1]);
            if (this.productategory[len - 1].id != "custom") {
              this.productategory[len] = cust;
            }
          }
          this.forms.is_amount = ""; //除了药品之外，带量采购为空
          this.forms.is_clinical = ""; //除了技术服务之外，临床科室为空
          this.forms.indications = ""; //除药品外，功能主治为空
          this.clinical.length = 0; //选技术服务之外，临床科室为空
        } else {
          this.shownutrition = false; //产品特点（营养保健品）隐藏
          this.shownutritions = true;
          this.distributionChannelVal1.length = 0;
          this.forms.is_import = "";
          if (newValue == 1) {
            //药品
            this.productategory = this.productcategorydrug; //PC药品类别=》产品类别一级
            this.forms.is_clinical = ""; //除了技术服务之外，临床科室为空
            this.clinical.length = 0; //选技术服务之外，临床科室为空
          }
          if (newValue == 2) {
            // 医疗器械
            this.productategory = this.productCategoryYL;
            this.forms.is_amount = ""; //除了药品之外，带量采购为空
            this.forms.is_clinical = ""; //除了技术服务之外，临床科室为空
            this.forms.indications = ""; //除药品外，功能主治为空
            this.clinical.length = 0; //选技术服务之外，临床科室为空
          }
          if (newValue == 3) {
            // 消卫产品
            this.productategory = this.productCategoryXW;
            this.forms.is_amount = ""; //除了药品之外，带量采购为空
            this.forms.is_clinical = ""; //除了技术服务之外，临床科室为空
            this.forms.indications = ""; //除药品外，功能主治为空
            this.clinical.length = 0; //选技术服务之外，临床科室为空
          }
          if (newValue == 4) {
            // 技术与服务
            this.productategory = this.productCategoryJS;
            this.forms.is_amount = ""; //除了药品之外，带量采购为空
            this.forms.indications = ""; //除药品外，功能主治为空
          }
        }
      } else {
        //添加产品第一次选择或者详情
        if (newValue == "313" || newValue == "314") {
          //产品特点营养保健品显示,并且产品一级可以选其他手动填写
          this.shownutrition = true;
          let cust = { id: "custom", val: "其他" };
          let len = this.productcategorynutrition.length;
          this.productategory = this.productcategorynutrition; //保健品类别=》产品类别一级
          this.productategory[len] = cust;
          this.shownutritions = false;
          if (newValue == 314) {
            //大类是原材，一级二级也要是原材
            let arr = [];
            this.productcategorynutrition.map((item) => {
              if (item.id == 367) {
                arr.push(item);
              }
            }); //367 产品类别一级 原材的id367
            console.log(arr);
            this.productategory = arr;
          } else {
            let len = this.productcategorynutrition.length;
            this.productategory = this.productcategorynutrition; //保健品类别=》产品类别一级
            let cust = { id: "custom", val: "其他" };
            if (this.productategory[len - 1].val != "其他") {
              this.productategory[len - 1] = cust;
            }
          }
        } else {
          this.shownutrition = false; //产品特点（营养保健品）隐藏
          this.shownutritions = true;
          if (newValue == 1) {
            //药品
            this.productategory = this.productcategorydrug; //PC药品类别=》产品类别一级
          }
          if (newValue == 2) {
            // 医疗器械
            this.productategory = this.productCategoryYL;
          }
          if (newValue == 3) {
            // 消卫产品
            this.productategory = this.productCategoryXW;
          }
          if (newValue == 4) {
            // 技术与服务
            this.productategory = this.productCategoryJS;
          }
        }
      }
    },
    //是否进口
    "forms.is_import"(newValue, oldValue) {
      if (oldValue != "") {
        // 修改=》选择
        this.distributionChannelVal1.length = 0;
        this.showdistributionChannel1 = false;
        this.showdistributionChannel2 = false;
        if (newValue == 1) {
          //进口
          this.showdistributionChannel1 = true;
          this.showdistributionChannel2 = false;
        }
        if (newValue == 0) {
          //非进口
          this.showdistributionChannel1 = false;
          this.showdistributionChannel2 = true;
        }
      }
      if (oldValue == "") {
        // 新增=》选择
        if (this.distributionChannelVal1.length == 0) {
          if (newValue == 1) {
            //进口
            this.showdistributionChannel1 = true;
            this.showdistributionChannel2 = false;
          }
          if (newValue == 0) {
            //非进口
            this.showdistributionChannel1 = false;
            this.showdistributionChannel2 = true;
          }
        }
      }
    },
    //产品特点自定义字数限制5
    featuresValCustom(newValue, oldValue) {
      if (newValue.length > 5) {
        alert("产品特点-自定义，字数不能超过5个字，请重新输入");
        this.featuresValCustom = "";
        return;
      }
    },
    //搜索标签限制最多5个词，字数30，并且限制特殊字符的输入
    "forms.search_label"(newValue, oldValue) {
      console.log(newValue.length);
      let arr = newValue.split("，");
      if (arr.length > 5) {
        alert("最多5个搜索标签");
        arr.length = 5;
        this.forms.search_label = arr.join("，");
        return;
      }
      if (newValue.length > 30) {
        alert("搜索标签字数不能超过30");
        this.forms.search_label = newValue.substr(0, 30);
        return;
      }
      var reg = new RegExp(
        "[`~!@#$^&*()=|{}':;'\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“'。、？]"
      );
      console.log(newValue, reg.test(newValue));
      if (reg.test(newValue) && newValue != "") {
        alert("禁止输入特殊字符");
        this.forms.search_label = newValue.replace(reg, "");
        console.log(this.forms.search_label);
      }
    },
  },
  data() {
    return {
      loading: false,
      active: 1,
      btnDisabled: false,
      cid: "", //产品类别一级选中的id
      showotc: false, //OTC/处方药显隐
      checkid: [],
      showeclinicalValCustom: false,
      clinicalValCustom: "",
      allproducChannel: "", //被选中的产品渠道的总值
      agent_regulationsList: [], //代理商要求列表
      provide_supportList: [], //提供的支持列表
      wxPhones: false, //微信同号
      // domian:'pharmchina.indata3.com',
      domian: "",
      protocol: "", //http:,https
      shownutritions: true, //PC药品相关筛选项显隐
      distributionChannelVal1Custom: "", //进口销售渠道其他选项值
      showdistributionChannelVal1: false, //进口销售渠道选其他
      distributionChannelVal1: [], //销售渠道进口
      distributionChannelVal2: [], //销售渠道非进口
      productClass1ValCustom: "", //产品类别一级选其他（属于营养保健品大类）
      shownutrition: false, //是否展示产品特点营养保健品
      testphone: false, //手机号验证
      testtel: false, //电话验证
      testemail: false, //邮箱验证
      testweb: false, //网址验证
      showdistributionChannel1: false, //是进口
      showdistributionChannel2: false, //不是进口
      features: [], //产品特点
      bid_area: [], //中标区域
      clinical: [], //临床
      investment_area: [], //招商区域
      hostnae: "", //域名
      imgs: [], //产品图片
      showlist_year: false, //新药上市年份显隐
      qualificationNone: false, //无特殊资质的隐藏
      showProductQualificationValCustom: false, //产品资质其他显隐
      qualificationVal: "", //产品资质
      showProductChannelsValcustom: false, //产品渠道显隐
      product_channel_class1id: "", //产品渠道一级id
      showethnodrugValCustom: false, //民族药选其他
      showfeaturesValCustom: "", //自定义产品特点显隐
      productClass1id: "", //产品类别一级id
      productcategorydrug: [], //产品类别一级(PC药品)
      productcategorynutrition: [], //产品类别一级（营养保健品）
      productCategoryXW: [], //['产品分类(消卫产品)'];
      productCategoryYL: [], //['产品分类(医疗器械)'];
      productCategoryJS: [], //['产品分类(技术与服务)'];
      productCategories: [], //产品大类
      productategory: [], //产品类别一级
      productategory2: [], //产品类别二级
      productFeature: [], //产品特点
      productnutrition: [], //产品特点(营养保健品)
      featuresValCustom: "", //产品特点自定义
      OTCRxDrug: [], //是OTC或处方药
      winningArea: [], //中标区域
      ethnodrugs: [], //民族药
      outbidsVal: "", //是否中标
      ethnodrugVal: "", //是否民族药
      clinicVal: "", //是否临床
      clinic: [], //临床科室
      qualification_no: "", //产品资质编号
      ProductChannels: [], //产品渠道一级
      ProductChannels2: [], //产品渠道二级
      distributionChannel1: [], //销售渠道1，
      distributionChannel2: [], //销售渠道2
      ProductChannelsValcustom: "", //自定义产品渠道
      ProductQualificationValCustom: "", //产品资质自定义
      qualificationid: "", //产品资质id
      ProductFormulations: [], //产品剂型
      investmentArea: [], //招商区域
      ethnodrugValCustom: "", //民族药自定义
      wxPhone: "", //微信与手机号一致
      ProductQualificationNutrition: [
        {
          //产品资质保健品（选保健食品（蓝帽子）、营养补充剂、特殊医学用途配方食品）
          id: "1",
          val: "国食健字G",
        },
        {
          id: "2",
          val: "国食健字J",
        },
        {
          id: "3",
          val: "国食健注G",
        },
        {
          id: "4",
          val: "国食健注J",
        },
        {
          id: "5",
          val: "卫食健字(____)第___号",
        },
        {
          id: "6",
          val: "卫进食健字(____)第___号",
        },
        {
          id: "7",
          val: "食健备G",
        },
        {
          id: "8",
          val: "食健备J",
        },
        {
          id: "9",
          val: "国食注字T",
        },
        {
          id: "10",
          val: "无",
        },
      ],

      ProductQualificationNutritionCustom: [
        {
          //产品资质保健品（选除以上其他选项）
          id: "9",
          val: "许可证编号",
        },
        {
          id: "10",
          val: "其他",
        },
        {
          id: "11",
          val: "无",
        },
      ],
      ProductQualificationDrug: [
        {
          //产品资质PC药品
          id: "1",
          val: "批准文号：国药准字B",
        },
        {
          id: "2",
          val: "批准文号：国药准字H",
        },
        {
          id: "3",
          val: "批准文号：国药准字Z",
        },
        {
          id: "4",
          val: "批准文号：国药准字S",
        },
        {
          id: "5",
          val: "进口注册证号：H",
        },
        {
          id: "6",
          val: "进口注册证号：Z",
        },
        {
          id: "7",
          val: "进口注册证号：S",
        },
        {
          id: "8",
          val: "注册证编号：",
        },
        {
          id: "9",
          val: "备案号：",
        },
        {
          id: "10",
          val: "许可证号：",
        },
        {
          id: "11",
          val: "其他",
        },
        {
          id: "12",
          val: "无特殊资质",
        },
      ],
      ProductQualification: [], //产品资质
      is_uniformity: [
        {
          id: 1,
          val: "是",
        },
        {
          id: 0,
          val: "否",
        },
      ],
      is_amount: [
        {
          id: 1,
          val: "是",
        },
        {
          id: 0,
          val: "否",
        },
      ],
      shelves: [
        {
          id: 1,
          val: "上架",
        },
        {
          id: 0,
          val: "下架",
        },
      ],
      entrance: [
        {
          //是否进口
          id: 1,
          val: "是",
        },
        {
          id: 0,
          val: "否",
        },
      ],
      ethnodrug: [
        {
          //是否是民族药
          id: 1,
          val: "是",
        },
        {
          id: 0,
          val: "否",
        },
      ],
      outbids: [
        {
          //是否中标
          id: 1,
          val: "是",
        },
        {
          id: 0,
          val: "否",
        },
      ],
      Isclinic: [
        {
          //是否临床
          id: 1,
          val: "是",
        },
        {
          id: 0,
          val: "否",
        },
      ],
      issyncwechat: [
        {
          id: "0",
          val: "与微信一致",
        },
        {
          id: "1",
          val: "与微信一致",
        },
      ],
      productQualificationid: "", //产品资质选中id
      fileList: [],
      productFeatures: [], //药品：产品特点原数组
      forms: {
        id: "",
        status: 0,
        is_amount: "", //采购数量
        is_uniformity: "", //一致性评价
        sales_channel: "", //销售渠道
        goodsName: "", //产品名称
        // sort:'0',//排序
        img: "", //产品封面图
        companyid: "", //所属展商id
        companyName: "", //展商名称
        category: "", //产品大类
        productategoryVal: "", //产品类别
        productClass1: "", //产品类别1级
        productClass2: "", //产品类别2级
        features: "", //产品特点
        c_purchasing_bid: "", //集采中标
        g_purchasing_bid: "", //国谈中标
        list_year: "", //上市年份
        certificate: "", //证书
        imgs: [], //产品图片
        trademark: "", //商标
        is_otc: "", //otc或处方药
        is_bid: "", //是否中标
        bid_area: "", //中标区域
        prices_provincial_min: "", //最低挂网价格及省份
        is_ethnic: "", //是否民族药
        ethnic: "", //民族药
        search_label: "", //索索标签
        is_clinical: "", //是否临床
        clinical: "", //临床科室
        product_channel_class1: "", //产品渠道1级
        product_channel_class2: "", //产品渠道2级
        prescription_circulation: "", //处方流转情况
        f_identical_prices: "", //四同价格
        msrp: "", //建议零售价
        online_available: "", //电商是否有货
        online_price_min: "", //电商底价
        qualification_file: "", //资质文件
        qualification: "", //产品资质
        approval_time: "", //产品资质获批时间
        is_import: "", //是否进口
        producer: "", //生产厂家
        specifications: "", //产品规格
        reagent_type: "", //产品剂型
        annex: "", //附件
        investment_area: "", //招商区域
        indications: "", //功能主治
        introduction: "", //产品介绍
        agent_regulations: "", //对代理商要求
        provide_support: "", //对提供的要求
        contacts: "", //联系人姓名
        phone: "", //手机号
        sync_wechat: "0", //微信手机号一致
        email: "",
        wechat: "",
        qq: "",
        tel: "",
        fax: "",
        website: "", //企业网址
        postal_code: "", //邮政编码
        contact_address: "",
        dosage: "", //用法用量
        advantages: "", //产品优势
        component: "", //药品成分
        updatetime: "",
        inputtime: "",
        store_main: "0", // 店铺主推
        store_new: "0", // 店铺新品
      },
      id: "", //产品详情的id
      categoryId: "", //产品大类当前id
      dialogTreeVisible: false,
      ProductChannelsData: [],
      ProductChannelsCheckedData: [],
      headers: {},
      dialogVisible: false,
      dialogImageUrl: "",
      checkStrictly: false,
      progressCertificateVisible: false,
      progressCertificatePercent: 0,
      progressImgsVisible: false,
      progressImgsPercent: 0,
      progressQfVisible: false,
      progressQfPercent: 0,
      pickerOption: {
        disabledDate(date) {
          if (!date) return false; // 如果日期为空，允许选择
          const today = new Date();
          today.setHours(0, 0, 0, 0); // 设置为当天的00:00:00
          const tomorrow = new Date(today);
          tomorrow.setDate(today.getDate() + 1); // 计算明天的日期
          return date.getTime() >= tomorrow.getTime(); // 禁用明天及之后的日期
        },
      },
      cpurchasingOptions: [], //集采中标选项
      gpurchasingOptions: [], //国谈中标选项
      isCpurchasing: false, // 是否选中集采中标选项
      isGpurchasing: false, // 是否选中国谈中标选项
      prescriptionOptions: [], //处方流转情况
      onlineAvailableOptions: [
        {
          key: "是",
          value: "是",
        },
        {
          key: "否",
          value: "否",
        },
      ], //电商是否有货选项
    };
  },
  mounted() {
    let stepMenuList = JSON.parse(localStorage.getItem("menu"));
    this.stepMenuList = stepMenuList;
    var index = stepMenuList.findIndex(function (item) {
      return item.link_url == "conference" && item.id == 7;
    });
    this.active = index;
    let token = localStorage.getItem("token");
    this.headers = {
      token: token,
    };
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    this.forms.companyName = userdata.name_cn;
    this.id = this.$route.query.id;
    this.forms.id = this.$route.query.id;
    this.getoptionData();
    //24.9.12 获取选项 dxm
    this.getCheckBoxData();
  },
  created() {},
  methods: {
    //24.9.5 产品渠道选择其他-输入项 dxm
    getProductChannelsValcustom(val) {
      this.ProductChannelsValcustom = val;
      if (val) {
        this.forms.product_channel_class1 +=
          "," + this.ProductChannelsValcustom;
      }
    },
    //24.9.13 产品院外处方流转情况 dxm
    changePrescriptionCirculation(val) {
      this.forms.f_identical_prices = "";
      this.forms.msrp = "";
      this.forms.online_available = "";
      this.forms.online_price_min = "";
    },
    //产品类别一级修改时，产品类别二级清空
    productClass1Change(val) {
      this.forms.productClass2 = "";
      // 24.9.13 产品类别一级在修改时，产品院外处方流转情况相关值清空
      this.forms.prescription_circulation = "";
      this.forms.f_identical_prices = "";
      this.forms.msrp = "";
      this.forms.online_available = "";
      this.forms.online_price_min = "";
    },
    // 新药证书上传成功
    handleCertificateSuccess(resData, file, fileList) {
      if (resData.code == 0) {
        this.$message.error(resData.msg);
        return false;
      }
      this.forms.certificate = resData.data.url;
      this.progressCertificateVisible = false;
    },
    // 新药证书上传失败
    handleCertificateError(err, file, fileList) {
      this.$message.error(err.message);
      this.progressCertificateVisible = false;
    },
    //删除新药证书
    handleCertificateRemove(file, fileList) {
      this.forms.certificate = "";
    },
    //产品图片上传成功
    handleImgsSuccess(resData, file, fileList) {
      if (resData.code == 0) {
        this.$message.error(resData.msg);
        return false;
      }
      this.forms.imgs.push(resData.data.url);
      this.progressImgsVisible = false;
    },
    //产品图片上传失败
    handleImgsError(err, file, fileList) {
      this.$message.error(err.message);
      this.progressImgsVisible = false;
    },
    //企业店铺宣传删除
    handleImgRemove(index) {
      this.$alert("确定要删除吗!", "", {
        confirmButtonText: "确定",
        callback: (action) => {
          if (action == "confirm") {
            this.forms.imgs.splice(index, 1);
          }
        },
      });
    },
    // 资质文件上传成功
    handleQfSuccess(resData, file, fileList) {
      if (resData.code == 0) {
        this.$message.error(resData.msg);
        return false;
      }
      this.forms.qualification_file = resData.data.url;
      this.progressQfVisible = false;
    },
    // 资质文件上传失败
    handleQfError(err, file, fileList) {
      this.$message.error(err.message);
      this.progressQfVisible = false;
    },
    //删除资质文件
    handleQfRemove(file, fileList) {
      this.$alert("确定要删除吗!", "", {
        confirmButtonText: "确定",
        callback: (action) => {
          if (action == "confirm") {
            this.forms.qualification_file = "";
          }
        },
      });
    },
    //上传图片进度
    handleProgressCertificate(event, file, fileList) {
      // 显示进度条
      this.progressCertificateVisible = true;
      // 计算进度百分比
      this.progressCertificatePercent = Math.floor(
        (event.loaded / event.total) * 100
      );
    },
    handleProgressImgs(event, file, fileList) {
      // 显示进度条
      this.progressImgsVisible = true;
      // 计算进度百分比
      this.progressImgsPercent = Math.floor((event.loaded / event.total) * 100);
    },
    handleProgressQf(event, file, fileList) {
      // 显示进度条
      this.progressQfVisible = true;
      // 计算进度百分比
      this.progressQfPercent = Math.floor((event.loaded / event.total) * 100);
    },
    //限制用户上传的图片大小
    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 7;
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 7MB!");
      }
      return isLt2M;
    },
    //预览图片
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file;
      this.dialogVisible = true;
    },
    //产品分类
    productTypelist() {
      productTypelist({})
        .then((res) => {
          if (res.data.code == 1) {
            this.menuOptions = res.data.data.lists;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //获取分类
    getoptionData() {
      optionData()
        .then((res) => {
          if (res.data.code == 1) {
            if (this.id) {
              this.getDetails(this.id);
            } else {
              // this.buildTree(this.copyProductChannels);
            }
            let { data } = res.data;
            this.productCategories = data.lists["产品大类"];
            this.productcategorydrug = data.lists["产品分类(药品)"]; //PC药品
            this.productCategoryXW = data.lists["产品分类(消卫产品)"];
            this.productCategoryYL = data.lists["产品分类(医疗器械)"];
            this.productCategoryJS = data.lists["产品分类(技术与服务)"];
            this.productFeatures = data.lists["产品特点"];
            this.productFeatures.push({
              id: "custom",
              val: "自定义",
            });
            this.winningArea = data.lists["中标区域"];
            this.ethnodrugs = data.lists["民族药"];
            this.ethnodrugs.push({
              id: "custom",
              val: "其他",
            });
            this.clinic = data.lists["临床科室"];
            this.clinic.push({
              id: "custom",
              val: "其他",
            });
            this.ProductChannels = data.lists["产品渠道"];
            this.ProductChannels.push({
              id: "custom",
              val: "其他",
            });
            let ProductChannelsArr = [];
            let ProductChannelsData = this.ProductChannels;
            ProductChannelsData.forEach((item) => {
              if (item.items) {
                let children = [];
                item.items.forEach((_item) => {
                  children.push({
                    id: _item.id,
                    label: _item.val,
                  });
                });
                ProductChannelsArr.push({
                  id: item.id,
                  label: item.val,
                  disabled: true,
                  children,
                });
              } else {
                ProductChannelsArr.push({
                  id: item.id,
                  label: item.val,
                });
              }
            });
            this.ProductChannelsData = ProductChannelsArr;
            this.ProductFormulations = data.lists["产品剂型"];
            this.OTCRxDrug = data.lists["OTC/处方药"];
            this.investmentArea = data.lists["招商区域"];

            this.productcategorynutrition = data.lists["产品分类(营养保健)"];
            this.productnutrition = data.lists["产品特点(营养保健)"];
            this.distributionChannel1 = data.lists["主要销售渠道(进口)"];
            this.distributionChannel2 = data.lists["主要销售渠道(非进口)"];

            this.copyProductChannels = [];
            for (var i = 0; i < this.ProductChannels.length; i++) {
              let item = this.ProductChannels[i];
              this.copyProductChannels[i] = {
                title: item.val,
                id: item.id,
                children: [],
              };
              if (item.hasOwnProperty("items")) {
                for (var j = 0; j < item.items.length; j++) {
                  let items = item.items[j];
                  this.copyProductChannels[i]["children"][j] = {
                    title: items.val,
                    id: items.id,
                  };
                }
              }
            }
          }
        })
        .catch((err) => {});
    },
    // 产品大类
    getCategory(e) {
      this.productCategories.map((item) => {
        if (item.id == e) {
          this.categoryId = item.id;
          this.forms.category = item.val;
        }
      });
      let plen = this.productFeatures.length;
      if (this.categoryId !== 1) {
        //如果不是药品，不要医保甲类医保乙类
        //this.productFeature = this.productFeatures.slice(2, plen);
        if (this.categoryId != 3 && this.categoryId != 4) {
          //如果不是药品，不要医保甲类医保乙类
          this.productFeature = this.productFeatures.slice(2, plen);
        } else {
          //如果不是药品和医疗器械，不要集采产品／国谈产品
          this.productFeature = this.productFeatures.slice(4, plen);
        }
      } else {
        //是药品，显示全部
        this.productFeature = this.productFeatures;
      }
      this.forms.productClass1 = "";
      this.forms.productClass2 = "";
      this.forms.is_import = "";
      this.isCpurchasing = false;
      this.forms.c_purchasing_bid = "";
      this.isGpurchasing = false;
      this.forms.g_purchasing_bid = "";
      this.$forceUpdate();
    },
    //产品资质
    getQualificationVal(e) {
      this.ProductQualification.map((item) => {
        if (item.id == e) {
          this.qualificationVal = item.val;
        }
      });
    },
    // 产品详情
    getDetails(product_long_id) {
      this.loading = true;
      let data = this.$qs.stringify({
        product_long_id,
      });
      productDetails(data)
        .then((res) => {
          //console.log(res, "======res");
          this.loading = false;
          if (res.data.code == 1) {
            let { data } = res.data;
            if (data.product_channel_class1.includes("，")) {
              data.product_channel_class1 = data.product_channel_class1.replace(
                /，/g,
                ","
              );
            } else {
              data.product_channel_class1 = data.product_channel_class1;
            }
            if (data.product_channel_class2.includes("，")) {
              data.product_channel_class2 = data.product_channel_class2.replace(
                /，/g,
                ","
              );
            }

            this.forms = data;
            this.productCategories.map((item) => {
              if (item.val == this.forms.category) {
                this.categoryId = item.id;
              }
            });
            let plen = this.productFeatures.length;
            //console.log(plen);
            if (this.categoryId !== 1) {
              //如果不是药品，不要医保甲类医保乙类
              //this.productFeature = this.productFeatures.slice(2, plen);
              if (this.categoryId != 3 && this.categoryId != 4) {
                //如果不是药品，不要医保甲类医保乙类
                this.productFeature = this.productFeatures.slice(2, plen);
              } else {
                //如果不是药品和医疗器械，不要集采产品／国谈产品
                this.productFeature = this.productFeatures.slice(4, plen);
              }
            } else {
              //是药品，显示全部
              this.productFeature = this.productFeatures;
            }

            if (this.categoryId == "313" || this.categoryId == "314") {
              // 营养保健
              this.productategory = this.productcategorynutrition;
            }
            if (this.categoryId == 1) {
              //药品
              this.productategory = this.productcategorydrug; //PC药品类别=》产品类别一级
            }
            if (this.categoryId == 2) {
              // 医疗器械
              this.productategory = this.productCategoryYL;
            }
            if (this.categoryId == 3) {
              // 消卫产品
              this.productategory = this.productCategoryXW;
            }
            if (this.categoryId == 4) {
              // 技术与服务
              this.productategory = this.productCategoryJS;
            }
            let caterlen = this.productategory.find((item) => {
              if (item.val == this.forms.productClass1) {
                return item;
              }
            });
            if (caterlen == undefined) {
              //产品类别一级其他
              this.productClass1ValCustom = this.forms.productClass1;
              this.forms.productClass1 = "其他";
            }

            //产品特点其他
            if (this.forms.features.indexOf(",") > -1) {
              this.features = this.forms.features.split(",");
            } else {
              this.features.push(this.forms.features);
            }
            //产品特点PC药品
            if (
              this.forms.category != "营养保健" &&
              this.forms.category != "原料/包材/设备"
            ) {
              let arr = [];
              this.productFeature.map((item) => {
                arr.push(item.val);
              });
              let conten = this.features.filter((item) => !arr.includes(item)); //自定义的内容
              if (conten != "") {
                this.featuresValCustom = conten[0];
                this.showfeaturesValCustom = true;
                let ind = this.features.indexOf(conten[0]);
                this.features[ind] = "自定义";
                //console.log(this.features, ind);
              }
            }
            if (this.forms.c_purchasing_bid != "") {
              this.isCpurchasing = true;
            }
            if (this.forms.g_purchasing_bid != "") {
              this.isGpurchasing = true;
            }
            if (this.forms.features.includes("集采产品")) {
              this.isCpurchasing = true;
            } else {
              this.isCpurchasing = false;
              this.forms.c_purchasing_bid = "";
            }
            if (this.forms.features.includes("国谈产品")) {
              this.isGpurchasing = true;
            } else {
              this.isGpurchasing = false;
              this.forms.g_purchasing_bid = "";
            }
            //民族药其他
            let ethbicarr = [];
            this.ethnodrugs.map((item) => {
              ethbicarr.push(item.val);
            });
            let conten1 = ethbicarr.indexOf(this.forms.ethnic);
            if (conten1 == -1 && this.forms.ethnic != "") {
              //民族药自定义内容
              this.ethnodrugValCustom = this.forms.ethnic;
              this.showethnodrugValCustom = true;
              this.forms.ethnic = "其他";
            }
            // 中标区域
            if (this.forms.bid_area != "") {
              this.bid_area = this.forms.bid_area.split(",");
            }

            // 临床科室
            if (this.forms.clinical != null && this.forms.clinical.length > 0) {
              this.clinical = this.forms.clinical.split(",");
              let arr = [];
              this.clinic.map((item) => {
                arr.push(item.val);
              });
              let clinCustom = this.clinical.filter(
                (item) => !arr.includes(item)
              );
              if (clinCustom != "") {
                //临床科室其他
                let cind = this.clinical.indexOf(clinCustom[0]);
                this.clinical[cind] = "其他";
                this.clinicalValCustom = clinCustom[0];
              }
            }
            this.investment_area = this.forms.investment_area.split(",");
            // 产品渠道一级其他
            let channelarr = [];
            this.ProductChannels.map((item) => {
              channelarr.push(item.val);
            });
            let contentArr = this.forms.product_channel_class1.split(",");
            let conten2 = contentArr.filter(
              (item) => !channelarr.includes(item)
            );
            if (conten2 != "" && this.forms.product_channel_class1 != "") {
              conten2 = conten2.filter((item) => item && item.trim() !== "");
              this.ProductChannelsValcustom = conten2;
            }
            this.forms.product_channel_class2 =
              this.forms.product_channel_class2 == null
                ? ""
                : this.forms.product_channel_class2;
            this.checkid = [];
            //let channel1 = this.forms.product_channel_class1.split('，');
            this.copyProductChannels.map((item, index) => {
              item.children.map((items) => {
                if (
                  this.forms.product_channel_class2.indexOf(items.title) > -1
                ) {
                  this.checkid.push(items.id);
                }
              });
              if (
                this.forms.product_channel_class1.indexOf(item.title) > -1 &&
                !this.checkid.includes(item.id)
              ) {
                // console.log(
                //   this.forms.product_channel_class1.indexOf(item.title),
                //   item.title
                // );
                this.checkid.push(item.id);
              }
            });
            this.allproducChannel =
              this.forms.product_channel_class1 +
              this.forms.product_channel_class2;
            this.ProductChannelsCheckedData = this.allproducChannel.split(",");
            // 招商区域
            if (this.forms.investment_area == "全国") {
              this.investment_area.length = 0;
              this.investmentArea.map((item) => {
                this.investment_area.push(item.val);
              });
            } else {
              this.investment_area = this.forms.investment_area.split(",");
            }
            if (
              this.forms.category == "营养保健" ||
              this.forms.category == "原料/包材/设备"
            ) {
              //产品资质营养保健
              let lenqa = this.forms.qualification.length;
              let quali = this.ProductQualificationNutrition.concat(
                this.ProductQualificationNutritionCustom
              );
              let quaitem = quali.find((item) => {
                // console.log(item.val.indexOf(this.forms.qualification));
                if (this.forms.qualification.indexOf(item.val) > -1) {
                  return item;
                }
              });
              if (quaitem.id != "custom" && this.forms.qualification != "无") {
                this.qualificationVal = quaitem.val;
                this.qualificationNone = true;
                let lenq = this.qualificationVal.length;

                this.qualification_no = this.forms.qualification.substr(
                  lenq,
                  lenqa
                );
              } else if (this.forms.qualification == "无") {
                this.qualificationVal = "无";
                this.qualificationNone = false;
                this.showProductQualificationValCustom = false;
              } else {
                this.qualificationVal = "其他";
                this.showProductQualificationValCustom = true;
                this.ProductQualificationValCustom = this.forms.qualification;
                this.qualification_no = this.froms.qualification.substr(
                  2,
                  lenqa
                );
              }
            }
            if (
              this.forms.category != "营养保健" &&
              this.forms.category != "原料/包材/设备"
            ) {
              // 产品资质PC药品
              let lenqa = this.forms.qualification.length;
              if (this.forms.qualification == "无特殊资质") {
                this.qualificationNone = false;
                this.qualificationVal = "无特殊资质";
                this.showProductQualificationValCustom = false;
              } else if (
                this.forms.qualification.indexOf("批") > -1 ||
                this.forms.qualification.indexOf("进") > -1 ||
                this.forms.qualification.indexOf("注") > -1 ||
                this.forms.qualification.indexOf("备") > -1 ||
                this.forms.qualification.indexOf("许") > -1
              ) {
                //产品资质
                let nqualification = this.forms.qualification.replace(
                  /:/,
                  "："
                );
                let fica = this.ProductQualificationDrug.filter((data) => {
                  if (nqualification.indexOf(data.val) > -1) {
                    // console.log(nqualification.indexOf(data.val));
                    return data;
                  }
                });
                this.qualificationVal = fica[0].val;

                let lenq = this.qualificationVal.length;
                this.qualification_no = this.forms.qualification.substr(
                  lenq,
                  lenqa
                );
                // console.log(a);
                this.qualificationNone = true;
              } else {
                //其他资质
                this.qualificationVal = "其他";
                this.showProductQualificationValCustom = true;
                this.ProductQualificationValCustom = this.forms.qualification;
                this.qualification_no = this.forms.qualification.substr(
                  2,
                  lenqa
                );
              }
            }
            //24.9.13 如果产品类别一级不是化学药／中成药／生物医药，产品院外处方流转情况相关值清空
            if (
              this.forms.productClass1 != "化学药" &&
              this.forms.productClass1 != "中成药" &&
              this.forms.productClass1 != "生物医药"
            ) {
              this.forms.prescription_circulation = "";
              this.forms.f_identical_prices = "";
              this.forms.msrp = "";
              this.forms.online_available = "";
              this.forms.online_price_min = "";
            }

            // 销售渠道
            if (
              this.forms.category == "营养保健" ||
              this.forms.category == "原料/包材/设备"
            ) {
              let allsale = this.distributionChannel1.concat(
                this.distributionChannel2
              );
              let allsales = [];
              allsale.forEach((item) => {
                allsales.push(item.val);
              });
              let sale =
                this.forms.sales_channel != ""
                  ? this.forms.sales_channel.split(",")
                  : [];
              console.log(sale);
              let conten = sale.filter((item) => !allsales.includes(item));
              if (conten != "") {
                //其他渠道
                this.distributionChannelVal1 = sale;
                this.distributionChannelVal1Custom = conten[0];
                this.showdistributionChannelVal1 = true;
                let ind = sale.indexOf(conten[0]);
                this.distributionChannelVal1[ind] = "其他";
                console.log(this.distributionChannelVal1, ind);
              } else {
                this.distributionChannelVal1 = sale;
              }
              if (this.forms.is_import == 1) {
                let conten2 = this.distributionChannel2.filter((item) =>
                  sale.includes(item.val)
                );
                if (conten2.length > 0) {
                  // 如果是进口，并且有非进口渠道的选项，让一般贸易被选中
                  this.distributionChannelVal1.push("一般贸易");
                  this.showdistributionChannel1 = true;
                  this.showdistributionChannel2 = true;
                } else {
                  this.distributionChannelVal1 = sale;
                  this.showdistributionChannel1 = true;
                  this.showdistributionChannel2 = false;
                }
              }
              if (this.forms.is_import == 0) {
                this.showdistributionChannel1 = false;
                this.showdistributionChannel2 = true;
              }
            }
            // 微信同号
            this.forms.sync_wechat == 1
              ? (this.wxPhones = true)
              : (this.wxPhones = false);
            this.forms.sync_wechat == 1
              ? (this.forms.wechat = this.forms.phone)
              : (this.forms.wechat = "");
            // this.buildTree(this.copyProductChannels);
          }
        })
        .catch((err) => {});
    },
    //产品特点
    getfeatures(data) {
      console.log(data, "--data");
      let val = data;
      if (val.includes("集采产品")) {
        this.isCpurchasing = true;
      } else {
        this.isCpurchasing = false;
        this.forms.c_purchasing_bid = "";
      }
      if (val.includes("国谈产品")) {
        this.isGpurchasing = true;
      } else {
        this.isGpurchasing = false;
        this.forms.g_purchasing_bid = "";
      }
    },
    // 上市年份
    getListy(date) {
      console.log(date);
      this.forms.list_year = date;
    },
    // 获批时间
    geApproval(date) {
      console.log(date);
      this.forms.approval_time = date;
    },
    //验证网址
    testWeb() {
      let regurl =
        /^(https?\:\/\/)?((http[s]?\:\/\/)?(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-_]{0,61}[a-zA-Z0-9])\.)+([a-zA-Z]{2,6}|[a-zA-Z0-9-_]{2,}\.x{n--}i{d--}))$/;
      if (!regurl.test(this.forms.website)) {
        alert("请填写正确的网址");
        this.testweb = false;
      } else {
        this.testweb = true;
      }
    },
    // 验证电话
    testTel() {
      let regphone = /^\d{3,4}-\d{7,8}$/;
      if (!regphone.test(this.forms.tel)) {
        alert("请填写正确的电话");
        this.testtel = false;
      } else {
        this.testtel = true;
      }
    },
    //验证电子邮箱
    testEmail() {
      let regemail =
        /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
      if (!regemail.test(this.forms.email)) {
        alert("请填写正确的邮箱");
        this.testemail = false;
      } else {
        this.testemail = true;
      }
    },
    //验证手机号
    testPhone() {
      this.testphone = true;
    },
    //获得招商区域
    getarea(date) {
      //console.log(date, "=====data ");
      let currarea = document
        .getElementById("全国")
        .getElementsByTagName("input")[0];
      console.log(date, currarea.checked);
      if (date.indexOf("全国") > -1) {
        // 如果选的全国就全选
        if (currarea.checked == true) {
          if (this.investment_area.length == this.investmentArea.length - 1) {
            this.investment_area.shift();
          } else {
            this.investment_area = [];
            this.investmentArea.forEach((item) => {
              this.investment_area.push(item.val);
            });
          }
        }
      } else {
        if (
          currarea.checked == false &&
          this.investment_area.indexOf("全国") == -1 &&
          this.investment_area.length == this.investmentArea.length - 1
        ) {
          this.investment_area = [];
        }
      }
    },
    // 微信手机号是否一致
    issync_wechat() {
      if (this.wxPhones == true) {
        this.forms.sync_wechat = 1;
        this.forms.wechat = this.forms.phone;
      } else {
        this.forms.sync_wechat = 0;
        this.forms.wechat = "";
      }
      console.log(this.wxPhones, this.forms.sync_wechat);
    },
    //产品图片
    tirggerFile(event) {
      console.log(event);
      var file = event.target.files;
      let formdata = new FormData();
      console.log(file);
      if (file[0].size > 819200) {
        alert(file[0].name + "图片不能超过800kb,请重新上传");
        return;
      } else {
        console.log(file[0]);
        formdata.append("imgFile", file[0]);
        axios
          .post(
            this.protocol +
              "//" +
              this.domian +
              "/kindeditor/php/uploadApi.php?mode=3",
            formdata,
            { headers: { "Content-Type": "multipart/form-data" } }
          )
          .then((res) => {
            console.log(res);
            if (res.data.errno == "0") {
              this.forms.imgs.push(res.data.url);
            }
          });
      }
      // })
    },
    // 临床科室多选时控制只选三项
    getclinical(val) {
      console.log(val);
      if (this.clinical.length > 3) {
        alert("最多选三项");
        this.clinical = this.clinical.slice(0, 3);
        let currCheck1 = document.getElementById(val);
        console.log(currCheck1.checked);
        currCheck1.checked = false;
      }
    },
    // 销售渠道只选三项
    getdistribution(date) {
      console.log(date, this.distributionChannelVal1);
      // let currDi = document.getElementById(val).checked;
      if (date.indexOf("一般贸易") > -1) {
        // if(currDi == true){
        this.showdistributionChannel2 = true;
        if (this.distributionChannelVal1.length > 4) {
          alert("最多选四项");
          this.distributionChannelVal1 = this.distributionChannelVal1.slice(
            0,
            4
          );
          // let currCheck1 = document.getElementById(val);
          // console.log(currCheck1.checked);
          // currCheck1.checked = false;
        }
      }
      if (date.indexOf("其他") > -1) {
        this.showdistributionChannelVal1 = true;
        if (this.distributionChannelVal1.length > 3) {
          alert("最多选三项");
          this.distributionChannelVal1 = this.distributionChannelVal1.slice(
            0,
            3
          );
          let currCheck1 = document.getElementById(val);
          console.log(currCheck1.checked);
          currCheck1.checked = false;
        }
      }
      if (date.indexOf("一般贸易") == -1 && date.indexOf("其他") == -1) {
        if (this.distributionChannelVal1.length > 3) {
          alert("最多选三项");
          this.distributionChannelVal1 = this.distributionChannelVal1.slice(
            0,
            3
          );
          let currCheck1 = document.getElementById(val);
          console.log(currCheck1.checked);
          currCheck1.checked = false;
        }
      }
      if (date.indexOf("其他") == -1) {
        this.showdistributionChannelVal1 = false;
        this.distributionChannelVal1Custom = "";
      }
      if (date.indexOf("一般贸易") == -1) {
        this.showdistributionChannel2 = false;
        //取消一般贸易，删除选中的非进口渠道的选项
        let channer2 = this.distributionChannel2.filter((item, index) => {
          if (this.distributionChannelVal1.includes(item.val)) {
            let ind = this.distributionChannelVal1.indexOf(item.val);
            this.distributionChannelVal1.slice(ind, 1);
          }
        });
        console.log(this.distributionChannelVal1);
        if (this.forms.is_import == 0) {
          this.showdistributionChannel2 = true;
        }
      }
    },
    getChannel() {
      this.dialogTreeVisible = true;
      // 判断产品渠道是否有值
      if (this.ProductChannelsCheckedData.length > 0) {
        // 去除选中有二级的一级树的项
        let arr = this.ProductChannelsData.filter((item) => item.children);
        let arr1 = this.ProductChannelsCheckedData.filter(
          (item) => !arr.some((items) => items.label === item)
        );
        this.$nextTick(() => {
          this.$refs.tree.setCheckedKeys(arr1);
        });
      }
    },
    // 24.8.13 产品渠道弹框确定 dxm
    handleTreeClick() {
      // 获取所有选中节点的状态
      let allNodes = this.$refs.tree.getCheckedKeys();
      this.ProductChannelsCheckedData = allNodes;
      // 获取产品渠道完成数据
      let data = this.ProductChannelsData;
      let productOne = [];
      let productTwo = [];
      data.forEach((item) => {
        if (item.children) {
          item.children.forEach((items) => {
            allNodes.forEach((_items) => {
              if (items.label == _items) {
                productOne.push(item.label);
                productTwo.push(items.label);
              }
            });
          });
        } else {
          allNodes.forEach((_item) => {
            if (item.label == _item) {
              productOne.push(item.label);
            }
          });
        }
      });
      //产品渠道一级选中项
      if (productOne.length > 0) {
        productOne = productOne.filter(
          (item, index, self) => self.indexOf(item) === index
        );
        this.forms.product_channel_class1 = productOne.join(",");
        if (
          this.forms.product_channel_class1.includes("其他") &&
          this.ProductChannelsValcustom.length > 0
        ) {
          this.forms.product_channel_class1 +=
            "," + this.ProductChannelsValcustom;
        }
      } else {
        this.forms.product_channel_class1 = "";
      }
      //产品渠道二级选中项
      if (productTwo.length > 0) {
        this.forms.product_channel_class2 = productTwo.join(",");
      } else {
        this.forms.product_channel_class2 = "";
      }
      if (this.ProductChannelsCheckedData.length > 0) {
        this.forms.product_channel_class2 = this.forms.product_channel_class2
          ? "," + this.forms.product_channel_class2
          : this.forms.product_channel_class2;
        this.allproducChannel =
          this.forms.product_channel_class1 + this.forms.product_channel_class2;
      } else {
        this.allproducChannel = "";
      }
      this.dialogTreeVisible = false;
    },
    // 返回
    goBack() {
      this.$router.back();
    },
    //保存产品
    addProduct() {
      // 10月21号要求产品特点改为非必填项
      //  else if (this.features.length == 0) {
      //     alert('产品特点不能为空')
      //     return;
      // }
      if (this.forms.goodsName == "") {
        // alert("产品名称不能为空");
        this.$alert("产品名称不能为空");
        return;
      } else if (this.forms.category == "") {
        this.$alert("产品大类不能为空");
        return;
      } else if (this.forms.productClass1 == "") {
        this.$alert("产品类别一级不能为空");
        return;
      } else if (
        this.forms.productClass1 == "其他" &&
        this.productClass1ValCustom == ""
      ) {
        this.$alert("请填写产品类别一级");
        return;
      } else if (
        this.forms.productClass1 != "其他" &&
        this.forms.productClass2 == ""
      ) {
        this.$alert("产品类别二级不能为空");
        return;
      } else if (
        this.features.indexOf("自定义") > -1 &&
        this.featuresValCustom == ""
      ) {
        this.$alert("请输入自定义产品特点");
        return;
      } else if (this.isCpurchasing && this.forms.c_purchasing_bid == "") {
        this.$alert("请选择集采中标情况");
        return;
      } else if (this.isGpurchasing && this.forms.g_purchasing_bid == "") {
        this.$alert("请选择国谈中标情况");
        return;
      }
      let isAlert = true;
      if (this.forms.search_label.length > 0) {
        if (
          this.forms.search_label.indexOf("，") == -1 &&
          this.forms.search_label.length > 4
        ) {
          this.$alert("每个搜索标签字长不超过4个字");
          return;
        }
        if (this.forms.search_label.indexOf("，") > -1) {
          let searcharr = this.forms.search_label.split("，");
          searcharr.map((item) => {
            if (item.length > 4) {
              isAlert = false;
              this.$alert("每个搜索标签字长不超过4个字");
              return;
            }
          });
        }
      }
      if (!isAlert) {
        return false;
      }
      if (this.forms.productClass1 == "其他") {
        this.forms.productClass1 = this.productClass1ValCustom;
        this.forms.productClass2 = "";
      }
      if (this.features.indexOf("新药") > -1 && this.forms.certificate == "") {
        this.$alert("新药证书不能为空");
        return;
      }
      if (this.features.indexOf("新药") > -1 && this.forms.list_year == "") {
        this.$alert("请选择上市年份");
        return;
      }
      if (this.forms.imgs.length == 0) {
        this.$alert("请上传产品图片");
        return;
      }
      if (
        this.forms.category != "营养保健" &&
        this.forms.category != "原料/包材/设备"
      ) {
        //PC药品
        if (this.forms.is_otc == "" && this.showotc && this.categoryId == 1) {
          this.$alert("请选择OTC/处方药");
          return;
        } else if (
          this.forms.productClass1 == "化学药" &&
          this.forms.is_uniformity == "" &&
          this.forms.is_uniformity != 0
        ) {
          this.$alert("请选择是否一致性通过评价");
          return;
        } else if (
          this.categoryId == 1 &&
          this.forms.is_amount == "" &&
          this.forms.is_amount != 0
        ) {
          this.$alert("请选择是否带量采购品种");
          return;
        } else if (
          this.forms.is_clinical == "" &&
          this.forms.is_clinical != 0 &&
          this.categoryId != "4"
        ) {
          this.$alert("请选择是否临床");
          return;
        } else if (this.clinical.length == 0 && this.forms.is_clinical == 1) {
          this.$alert("临床科室不能为空");
          return;
        } else if (
          this.forms.category != "技术与服务" &&
          this.forms.product_channel_class1 == ""
        ) {
          this.$alert("产品渠道一级不能为空");
          return;
        } else if (
          this.forms.category != "技术与服务" &&
          this.forms.product_channel_class2 == "" &&
          this.ProductChannels2.length > 0
        ) {
          this.$alert("产品渠道二级不能为空");
          return;
        } else if (
          (this.qualificationVal != "无特殊资质" &&
            this.qualificationVal != "无" &&
            this.qualificationVal == "") ||
          (this.qualification_no == "" && this.qualificationNone)
        ) {
          if (this.forms.category != "技术与服务") {
            this.$alert("产品资质不能为空");
            return;
          }
        } else if (
          this.qualificationVal != "无" &&
          this.forms.qualification_file == "" &&
          this.qualificationVal != "无特殊资质"
        ) {
          this.$alert("请上传资质文件");
          return;
        } else if (
          this.qualificationVal != "无" &&
          this.qualificationVal != "无特殊资质" &&
          this.forms.approval_time == ""
        ) {
          this.$alert("请选择获批时间");
          return;
        } else if (this.forms.producer == "") {
          this.$alert("生产厂家不能为空");
          return;
        } else if (this.forms.specifications == "") {
          this.$alert("产品规格不能为空");
          return;
        } else if (
          this.forms.reagent_type == "" &&
          this.shownutritions &&
          this.categoryId == 1
        ) {
          this.$alert("产品剂型不能为空");
          return;
        } else if (this.investment_area.length == 0) {
          this.$alert("招商区域不能为空");
          return;
        } else if (this.forms.indications == "" && this.categoryId == 1) {
          this.$alert("功能主治不能为空");
          return;
        }
        if (this.clinical.indexOf("其他") > -1) {
          //临床科室选其他
          let ind = this.clinical.indexOf("其他");
          this.clinical[ind] = this.clinicalValCustom;
        }
      }
      // 24.9.12 选择药品、医疗器械的，是否中标/挂网和中标/挂网区域变为必填
      if (this.forms.category == "药品" || this.forms.category == "医疗器械") {
        if (this.forms.is_bid == "" && this.forms.is_bid != 0) {
          this.$alert("请选择是否中标/挂网");
          return;
        }
        if (this.forms.is_bid == "1" && this.bid_area.length == 0) {
          this.$alert("请选择中标/挂网区域");
          return;
        }
        if (
          this.forms.is_bid == "1" &&
          this.bid_area.length > 0 &&
          this.forms.prices_provincial_min == ""
        ) {
          this.$alert("请填写最低挂网价格及省份 ");
          return;
        }
      }
      if (
        !this.shownutritions &&
        this.forms.is_import != 0 &&
        this.forms.is_import != 1
      ) {
        this.$alert("请选择是否进口");
        return;
      }
      if (
        this.forms.category == "营养保健" ||
        this.forms.category == "原料/包材/设备"
      ) {
        if (
          (this.qualification_no == "" &&
            this.qualificationVal != "无特殊资质" &&
            this.qualificationVal != "无") ||
          (this.qualification_no == "" && this.qualificationNone)
        ) {
          this.$alert("产品资质不能为空");
          return;
        }
        if (this.forms.is_import == 1) {
          // 销售渠道进口不能为空
          if (
            this.distributionChannelVal1.length == 0 ||
            this.distributionChannelVal1[0] == ""
          ) {
            this.$alert("销售渠道不能为空");
            return;
          }
          if (
            this.showdistributionChannelVal1 == true &&
            this.distributionChannelVal1Custom == ""
          ) {
            //销售渠道其他
            this.$alert("请填写销售渠道");
            return;
          }
        } else if (
          (this.forms.is_import == 0 &&
            this.distributionChannelVal1.length == 0) ||
          this.distributionChannelVal1[0] == ""
        ) {
          //如果是非进口销售渠道
          this.$alert("销售渠道不能空");
          return;
        }
        if (this.forms.producer == "") {
          this.$alert("生产厂家不能为空");
          return;
        } else if (this.forms.specifications == "") {
          this.$alert("产品规格不能为空");
          return;
        } else if (this.investment_area.length == 0) {
          this.$alert("招商区域不能为空");
          return;
        }
        let mind = this.distributionChannelVal1.indexOf("一般贸易");
        if (mind > -1) {
          this.distributionChannelVal1.slice(mind, 1);
        }
      }
      // 24.9.12 只有选药品的化学药、中成药、生物医药,产品院外处方流转情况（必填）
      if (
        this.forms.productClass1 == "化学药" ||
        this.forms.productClass1 == "中成药" ||
        this.forms.productClass1 == "生物医药"
      ) {
        if (this.forms.prescription_circulation == "") {
          this.$alert("请选择产品院外处方流转情况");
          return;
        } else if (
          this.forms.prescription_circulation == "已进行" ||
          this.forms.prescription_circulation == "希望开展"
        ) {
          if (this.forms.msrp == "") {
            this.$alert("请填写建议零售价");
            return;
          }
          if (this.forms.online_available == "") {
            this.$alert("请选择电商是否有货");
            return;
          }
        }
      }
      const reg = /^1[3-9]\d{9}$/;
      if (this.forms.introduction == "" && this.categoryId != 1) {
        this.$alert("产品介绍不能为空");
        return;
      } else if (this.forms.category == "药品" && this.forms.dosage == "") {
        this.$alert("用法用量不能为空");
        return;
      } else if (this.forms.advantages == "") {
        this.$alert("产品优势不能为空");
        return;
      } else if (this.forms.contacts == "") {
        this.$alert("请填写联系人姓名");
        return;
      } else if (this.forms.phone == "") {
        this.$alert("请填写联系人手机号");
        return;
      } else if (!reg.test(this.forms.phone)) {
        this.$alert("请输入正确的手机号码");
        return;
      }
      if (this.distributionChannelVal1.length > 0) {
        let distributionChannel = [];
        if (this.distributionChannelVal1.indexOf("其他") > -1) {
          //如果进口销售渠道选其他
          let ind = this.distributionChannelVal1.indexOf("其他");
          this.distributionChannelVal1[ind] =
            this.distributionChannelVal1Custom;
        }
        distributionChannel = this.distributionChannelVal1;
        this.forms.sales_channel = distributionChannel.join(",");
        // }
      }
      if (this.showethnodrugValCustom == true) {
        //如果民族药选其他
        this.forms.ethnic = this.ethnodrugValCustom;
      }
      if (this.showfeaturesValCustom == true) {
        //产品特点自定义
        this.features[this.features.indexOf("自定义")] = this.featuresValCustom;
      }
      // 产品资质
      if (
        this.qualificationVal == "无特殊资质" ||
        this.qualificationVal == "无"
      ) {
        this.forms.qualification = this.qualificationVal;
      } else {
        this.forms.qualification =
          this.qualificationVal + this.qualification_no;
      }
      this.forms.features = this.features.join(",");
      this.forms.bid_area = this.bid_area.join(",");
      this.forms.clinical = this.clinical.join(",");
      if (this.investment_area.indexOf("全国") > -1) {
        this.forms.investment_area = "全国";
      } else {
        this.forms.investment_area = this.investment_area.join(",");
      }
      // zhang 24.4.16 去掉手机号校验规则
      // let reg = /^[1]([3-9])[0-9]{9}$/;
      // if(!reg.test(this.forms.phone) && this.forms.phone !=''){
      //     alert('请填写正确的手机号');
      //         return;
      // }
      let regemail =
        /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
      if (!regemail.test(this.forms.email) && this.forms.email != "") {
        alert("请填写正确的电子邮箱");
        return;
      }
      let regphone = /^\d{3,4}-\d{7,8}$/;
      if (!regphone.test(this.forms.tel) && this.forms.tel != "") {
        alert("请填写正确的电话");
        return;
      }
      // let regurl = /^([\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?)/;
      // if (!regurl.test(this.forms.website) && this.forms.website!='') {
      //     alert('请填写正确的企业网址');
      //         return;
      // }
      this.forms.mark = this.$route.query.mark;
      this.btnDisabled = true;
      if (this.id) {
        this.editProductUpdate(this.forms);
      } else {
        //添加产品
        this.addProductPut(this.forms);
      }
      setTimeout(() => {
        this.btnDisabled = false;
      }, 2000);
    },
    // 编辑产品保存
    editProductUpdate(data) {
      this.loading = true;
      editproduct(data)
        .then((res) => {
          this.loading = false;
          if (res.data.code == 1) {
            this.$message.success(res.data.msg);
            // 返回上一页
            setTimeout(() => {
              this.goBack();
            }, 500);
            //this.btnDisabled = false;
          } else {
            //this.btnDisabled = false;
            this.$message.warning(res.data.message);
          }
        })
        .catch((err) => {
          this.loading = false;
          //this.btnDisabled = false;
        });
    },
    //创建产品保存
    addProductPut(data) {
      this.loading = true;
      addproduct(data)
        .then((res) => {
          this.loading = false;
          if (res.data.code == 1) {
            this.$message.success(res.data.msg);
            // 返回上一页
            setTimeout(() => {
              this.goBack();
            }, 500);
            //this.btnDisabled = false;
          } else {
            //this.btnDisabled = false;
            this.$message.warning(res.data.message);
          }
        })
        .catch((err) => {
          this.loading = false;
          //this.btnDisabled = false;
        });
    },
    //24.9.12 获取选项 dxm
    getCheckBoxData() {
      getCheckBox("1562,1563,1565")
        .then((res) => {
          if (res.data.code == 1) {
            let data = res.data.data;
            // 集采中标选项
            this.cpurchasingOptions = data[1562];
            // 国谈中标选项
            this.gpurchasingOptions = data[1563];
            // 处方流转情况选项
            this.prescriptionOptions = data[1565];
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-button.is-disabled{
  background: #CECECE !important;
}
.tree-body /deep/ .el-dialog__body {
  height: 400px;
  overflow-y: scroll;
}
.content .el-button {
  color: #fff;
  position: absolute;
  bottom: 30px;
  left: 50%;
  background: #008dff;
}
.dialog-img {
  max-height: 500px;
  max-width: 100%;
  width: auto;
  margin: 0 auto;
  display: block;
}
.content {
  padding-top: 75px;
  padding-bottom: 40px;
  .main-title {
    margin-bottom: 20px;
  }
  .create-title {
    font-size: 22px;
    color: #646889;
    margin: 8px 0 50px;
  }
  .productContent {
    background: #fff;
    border-radius: 10px;
    padding: 20px;
    margin-top: 20px;
    .title {
      color: #3d83e9;
      padding-bottom: 10px;
      margin-bottom: 20px;
      border-bottom: 1px solid #3d83e9;
    }
    .product-list {
      display: flex;
      flex-wrap: wrap;
      .product-item {
        width: 40%;
      }
    }
    .product-item {
      display: flex;
      // align-items: center;
      font-size: 14px;
      color: #666;
      margin-bottom: 20px;
      .product-title {
        color: #333;
        font-size: 18px;
        font-weight: bold;
      }
      .colorRed {
        color: red;
      }
      .product-left {
        min-width: 170px;
        line-height: 35px;
        text-align: right;
      }
      .product-right {
        display: flex;
        width: 60%;
        flex-wrap: wrap;
        .el-select {
          width: 100%;
        }
        .el-checkbox {
          line-height: 35px;
        }
        .el-radio {
          line-height: 35px;
        }
        .others {
          width: 80%;
          margin-top: 10px;
        }
        .margint10px {
          margin-top: 10px;
        }
        .colorf90 {
          color: #f90;
        }
        .channels {
          height: 38px;
          line-height: 38px;
          padding: 0 20px;
          margin-left: 10px;
          cursor: pointer;
          border-radius: 4px;
          border: 1px solid #dcdfe6;
        }
        .productImgList {
          position: relative;
          .product-image {
            width: 150px;
            height: 200px;
          }
          .del {
            position: absolute;
            top: 0;
            right: 0;
            width: 20px;
            height: 20px;
          }
          .productImgItem {
            position: relative;
            width: 150px;
            height: 200px;
          }
        }
        .product-checkbox .el-checkbox {
          display: block;
        }
        .image-wrap {
          display: flex;
          flex-wrap: wrap;
          .image {
            margin: 0 10px 10px 0;
          }
        }
        .image {
          width: 148px;
          height: 148px;
          border-radius: 6px;
          position: relative;
          /deep/ .el-image {
            width: 148px;
            height: 148px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 6px;
            .el-image__inner {
              width: auto;
              height: auto;
              max-width: 100%;
              max-height: 100%;
            }
          }
          .upload-span {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba($color: #000, $alpha: 0.4);
            display: flex;
            align-items: center;
            justify-content: center;
            opacity: 0;
            transition: all 0.1s;
            border-radius: 6px;
            .upload-icon {
              color: #fff;
              font-size: 22px;
            }
          }
          &:hover {
            .upload-span {
              opacity: 1;
            }
          }
        }
      }
    }
    .product-img {
      color: #fff;
      border-radius: 4px;
      width: 100px;
      height: 32px;
      line-height: 32px;
      text-align: center;
      margin-bottom: 10px;
      background: #3d83e9;
    }
    #upload,
    #upload1,
    #upload2,
    #fj,
    #upload3 {
      width: 100px;
      height: 32px;
      top: 0;
      left: 0;
      z-index: 0;
      opacity: 0;
      position: absolute;
    }
  }
  .bus-btn {
    margin-top: 100px;
    text-align: center;
    .el-button {
      position: inherit;
      transform: translateX(0);
    }
  }
}
.hide-box /deep/ .el-upload--picture-card {
  display: none;
}
.dialog-footer .el-button {
  height: 40px;
  cursor: pointer;
  font-size: inherit;
  padding: 0 20px;
  min-width: inherit;
  border-radius: 4px;
  position: inherit;
  bottom: inherit;
  left: inherit;
  transform: inherit;
}
.content-top {
  display: flex;
  position: fixed;
  top: 100px;
  left: 260px;
  z-index: 99;
  width: 100%;
  padding: 30px 0 20px;
  background: #f1f5f8;
  .el-button {
    position: relative;
    left: 0;
    bottom: 0;
    height: 44px;
    line-height: 44px;
    margin-left: 20px;
    transform: translateX(0);
  }
}
@media only screen and (max-width: 767px) {
  .content {
    margin: 0;
    padding: 20px;
    .main-title {
      margin: 10px 0;
    }
    .productContent {
      .product-item {
        flex-wrap: wrap;
        margin-bottom: 10px;
        .product-left {
          min-width: 100px;
          text-align: left;
        }
        .product-right {
          width: 100%;
          .el-checkbox {
            margin-right: 20px;
          }
          .channels-input {
            width: 58% !important;
          }
          .channels {
            padding: 0 10px;
          }
        }
        .product-right .product-checkbox /deep/ .el-checkbox {
          display: flex;
          white-space: pre-wrap;
        }
      }
      .product-list {
        .product-item {
          width: 100%;
        }
      }
    }
  }
}
</style>